import React from "react";
import logger from "logger";
import Checkbox from "@material-ui/core/Checkbox";
import { getStyleJSON } from "Utils/Common";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getCityGenericNameFromNumber } from "Utils/Common";

export const HeroListCheckbox = (props) => {
  const { label, param, setTaskConfig, taskConfig } = props;
  const [allSelected, setAllSelected] = React.useState(false);

  const toggleSelectAll = () => {
    const newTaskConfig = { ...taskConfig };
    Object.keys(newTaskConfig.selectedheroes).forEach((key) => {
      const city = newTaskConfig.selectedheroes[key];
      city.forEach((hero) => {
        hero.selected = !allSelected;
      });
    });
    logger.log("newTaskConfig", newTaskConfig);
    setTaskConfig(newTaskConfig);
    setAllSelected(!allSelected);
  };

  return (
    <>
      <div>{label}</div>

      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={allSelected}
              onChange={() => {
                toggleSelectAll();
              }}
              style={{ paddingLeft: "0px" }}
            />
          }
          label="Toggle Select All"
          style={{
            width: "100%",
            marginLeft: "0px",
            paddingLeft: "0px",
          }}
        />
      </div>
      {Object.keys(taskConfig[param]).map((key) => {
        const value = taskConfig[param][key];
        logger.log("value", value);
        return (
          <div>
            {value.map((item) => {
              return (
                <div>
                  <div
                    style={getStyleJSON(
                      "padding-left: 40px; padding-right: 0px; padding-top: 0px; padding-bottom: 0px; width: 300px;"
                    )}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.selected}
                          onChange={() => {
                            item.selected = !item.selected;
                            setTaskConfig({ ...taskConfig });
                          }}
                          style={{ paddingLeft: "0px" }}
                        />
                      }
                      label={
                        item.name +
                        "(" +
                        getCityGenericNameFromNumber(key) +
                        ")"
                      }
                      style={{
                        width: "100%",
                        marginLeft: "0px",
                        paddingLeft: "0px",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};
